import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AurFormControl } from '../../models/form-control.model';
import { ErrorMessageModel } from '../../models/error-message.model';

@Component({
    selector: 'aur-number',
    template: `<mat-form-field [formGroup]="formGroup" fxFlex>
    <span *ngIf="control.prefix" matPrefix>{{ control.prefix }}</span>

    <input matInput
        type="number"
        [formControlName]="control.name"
        [readonly]="control.isReadonly"
        [placeholder]="control.placeholder"
        [required]="control.isRequired"
        [max]="control.max"
        [min]="control.min"
        step="{{ control.numberStep ? control.numberStep : 1 }}" />

    <span *ngIf="control.suffix" matSuffix>{{ control.suffix }}</span>

    <mat-error>
        {{ getErrorMessage() }}
    </mat-error>
</mat-form-field>`
})
export class NumberComponent {

    @Input() formGroup: FormGroup;
    @Input() control: AurFormControl;

    getErrorMessage(): string {
        return (<AurFormControl>this.formGroup.controls[this.control.name]).errorMessages
            .filter((errorMessage: ErrorMessageModel) => this.formGroup.controls[this.control.name].hasError(errorMessage.type))
            .map((errorMessage: ErrorMessageModel) => errorMessage.text)[0];
    }
}
